import { Dispatch } from 'redux';
import {
  CompareAttribute,
  CompareItem
} from '@common-modules/product-catalogue';
import { ACTION_TYPES } from '../constants/actions';

export interface ProductCompareState {
  items: CompareItem[];
  /** Snapshot of the catalogue page's available devices, reused by the compare page. */
  catalog: CompareItem[];
  /** Snapshot of the catalogue page's tech-spec schema, reused by the compare page. */
  schema: CompareAttribute[];
}

const initialState: ProductCompareState = {
  items: [],
  catalog: [],
  schema: []
};

type ProductCompareActions = {
  value?: CompareItem[] | CompareAttribute[];
  type: string;
};

export const productCompareReducer = (
  state: ProductCompareState = initialState,
  action: ProductCompareActions
): ProductCompareState => {
  switch (action.type) {
    case ACTION_TYPES.PRODUCT_COMPARE.SET_ITEMS:
      return { ...state, items: (action.value as CompareItem[]) || [] };
    case ACTION_TYPES.PRODUCT_COMPARE.SET_CATALOG:
      return { ...state, catalog: (action.value as CompareItem[]) || [] };
    case ACTION_TYPES.PRODUCT_COMPARE.SET_SCHEMA:
      return { ...state, schema: (action.value as CompareAttribute[]) || [] };
    case ACTION_TYPES.PRODUCT_COMPARE.CLEAR_ITEMS:
      return { ...state, items: [] };
    default:
      return state;
  }
};

export const setCompareItems = (value: CompareItem[]) => (
  dispatch: Dispatch
) => {
  dispatch({ type: ACTION_TYPES.PRODUCT_COMPARE.SET_ITEMS, value });
};

export const clearCompareItems = () => (dispatch: Dispatch) => {
  dispatch({ type: ACTION_TYPES.PRODUCT_COMPARE.CLEAR_ITEMS });
};

export const setCompareCatalog = (value: CompareItem[]) => (
  dispatch: Dispatch
) => {
  dispatch({ type: ACTION_TYPES.PRODUCT_COMPARE.SET_CATALOG, value });
};

export const setCompareSchema = (value: CompareAttribute[]) => (
  dispatch: Dispatch
) => {
  dispatch({ type: ACTION_TYPES.PRODUCT_COMPARE.SET_SCHEMA, value });
};
